import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { OwlDateTimeModule } from '@danielmoncada/angular-datetime-picker'
import { NgSelectComponent, NgOptionTemplateDirective } from '@ng-select/ng-select'
import { AppCommonModule } from '@common/app-common.module'
import { ElectronicProcessFormComponent } from './electronic-process-form.component'
import { ElectronicProcessPaginationModule } from '../electronic-process-pagination/electronic-process-pagination.module'
import { ElectronicProcessBooksModule } from '../electronic-process-books/electronic-process-books.module'

@NgModule({
	declarations: [ElectronicProcessFormComponent],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		OwlDateTimeModule,
		NgSelectComponent,
		NgOptionTemplateDirective,
		AppCommonModule,
		ElectronicProcessPaginationModule,
		ElectronicProcessBooksModule
	],
	exports: [ElectronicProcessFormComponent]
})
export class ElectronicProcessFormModule {}
